import type { ThemeConfig } from 'antd/es/config-provider'

const mainColor = '#f08200'

export const theme: ThemeConfig = {
  token: {
    colorPrimary: mainColor,
    colorPrimaryHover: `${mainColor}de`,
    colorPrimaryActive: `${mainColor}de`,
    fontFamily: 'inherit',
  },
  components: {
    Button: {
      colorPrimary: mainColor,
      colorPrimaryHover: `${mainColor}de`,
      colorPrimaryActive: `${mainColor}de`,
      defaultColor: '#666',
      defaultGhostColor: mainColor,
      defaultGhostBorderColor: mainColor,
      borderRadiusLG: 6,
    },
    Input: {
      hoverBorderColor: mainColor,
      activeBorderColor: mainColor,
    },
    Tooltip: {
      colorBgSpotlight: mainColor,
    },
    Cascader: {
      optionSelectedBg: mainColor,
      optionSelectedColor: '#fff',
    },
  },
}
